import styled from 'styled-components'
import { PinkGradient } from 'home/platform'
import PropTypes from 'prop-types'
import Wrapper from 'common/wrapper'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { Typography } from 'common/typography'
import { SecondaryButton } from 'common/button'

const StepStyled = styled.section`
  padding-block-start: 40px;
  padding-block-end: 40px;
  h2 {
    margin-block-end: 8px;
    ${PinkGradient}
  }
  .step-content {
    margin-block-end: 24px;
    padding-inline-start: 64px;
    flex: 1;
  }
  .step-img {
    display: flex;
    flex: 1;
    justify-content: center;
    filter: drop-shadow(0px 0px 64px rgba(97, 112, 216, 0.34));
  }
  .step-container {
    padding-block-start: 74px;
    position: relative;
  }
  a {
    margin-block-start: 16px;
  }
  @media(min-width: 768px) {
    padding-block-end: 40px;
    h2 {
      margin-block-end: 16px;
    }
  }
  @media(min-width: 1024px) {
    padding-block-start: 80px;
    padding-block-end: 80px;
    .step-container {
      display: flex;
      gap: 50px;
      align-items: flex-end;
      padding-block-start: 0;
    }
    .step-content {
      margin-block-end: 0px;
    }
    .step-content {
      padding-inline-start: 80px;
    }
  }
  @media(min-width: 1366px) {
    .step-img {
      min-width: 588px;
      min-height: 331px;
    }
  }
`

function ScholarshipStep({
  id, title, description, link, img, cta,
}) {
  return (
    <StepStyled role="region" aria-labelledby={id}>
      <Wrapper maxWidth={1200}>
        <div className="step-container">
          <div className="step-content">
            <Typography as="h2" id={id} small="headline5" large="headline4">
              {title}
            </Typography>
            <p>
              {description}
            </p>
            <Link href={link} passHref>
              <SecondaryButton responsive>
                {cta}
              </SecondaryButton>
            </Link>
          </div>
          <div className="step-img">
            <Image width={588} height={331} src={img} alt={img} />
          </div>
        </div>
      </Wrapper>
    </StepStyled>
  )
}

ScholarshipStep.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
}

export default ScholarshipStep
